import { Injectable } from '@angular/core';

type ThemePreference = 'system' | 'light' | 'dark';

@Injectable({ providedIn: 'root' })
export class ThemeService {

  /**
   * Apply a theme preference to the document root.
   * - 'system': remove manual override; let the browser @media (prefers-color-scheme) decide.
   * - 'dark':   force dark by adding ion-palette-dark class.
   * - 'light':  force light by removing ion-palette-dark class.
   * No-op when value is missing or unrecognised.
   */
  apply(value: ThemePreference | string | null | undefined): void {
    try {
      const root = document.documentElement;
      if (value === 'dark') {
        root.classList.add('ion-palette-dark');
      } else if (value === 'light') {
        root.classList.remove('ion-palette-dark');
      } else {
        // 'system' (or unset/unknown) — defer to browser media query
        const prefersDark = window.matchMedia
          ? window.matchMedia('(prefers-color-scheme: dark)').matches
          : false;
        root.classList.toggle('ion-palette-dark', prefersDark);
      }
    } catch (e) {
      console.warn('ThemeService.apply failed', e);
    }
  }

  /**
   * Initialise theme on app startup without a saved user preference.
   * Defers to browser default so the page loads correctly even before auth.
   */
  applyDefault(): void {
    this.apply('system');
  }
}
